import { createSelector } from '@reduxjs/toolkit';

const getAlertsEntity = ({ alerts }) => alerts;

export const getAlerts = createSelector(getAlertsEntity, ({ alerts }) => alerts);
